export const REQUEST_HOMEOWNER_COMPANY_DETAIL =
	"REQUEST_HOMEOWNER_COMPANY_DETAIL";
export const RECEIVE_HOMEOWNER_COMPANY_DETAIL =
	"RECEIVE_HOMEOWNER_COMPANY_DETAIL";